<template>
  <div class="table_actions">
    <call-tooltip
      placement="top"
      content="Edit">
      <call-button
        outlet
        type="warning"
        round
        not-border
        :icon="dataReadingIcon"
        @click="clickAction('update')" />
    </call-tooltip>
  </div>
</template>

<script>
import CallButton from '../common/CallButton';
import { faPen } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'CallTableIssuesActions',
  components: { CallButton },
  props: {
    blocked: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataReadingIcon: faPen
    };
  },
  methods: {
    clickAction (action) {
      this.$emit('on-action', action);
    }
  }
};
</script>
